import * as React from "react";
const CircleFillIcon = ({
  size = 16,
  title = "CircleFillIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Z", fill: "currentColor" }));
export default CircleFillIcon;
